module.exports = __webpack_public_path__ + "static/media/EF-mono.5f495021.jpg";